const _ = require('lodash');
const atmGlobalMapper = require('./atm-global-mapper');
const StoreMapper = require('../../../shop/components/shoplocator/atm/set-store-mapper');
const SearchMapper = require('../../../shop/components/search/atm/search-mapper');
const TrolleyMapper = require('./trolly-product-update');

function atm($window, $injector, AtmLocalService, $state, globalContextService, $log, $location, $timeout) {
    this.isInit = false;
    this.$injector = $injector;
    this.$window = $window;
    this.AtmLocalService = AtmLocalService;
    this.$state = $state;
    this.globalContextService = globalContextService;
    this.$log = $log;
    this.$timeout = $timeout;
    this.$location = $location;
}

atm.prototype.pushTrolleyProductsMapper = function (products) {
    if (this.$location.path() !== '/checkout/confirmation') {
        this.push(products, TrolleyMapper);
    }
};

atm.prototype.pushWithStoreMapper = function (data, isRecursive) {
    this.push(data, StoreMapper, isRecursive);
};

atm.prototype.pushWithSearchMapper = function (data, isRecursive) {
    this.push(data, SearchMapper, isRecursive);
};

atm.prototype.push = function (data, mapperFn, isRecursive, customArea) {
    /// <summary>
    /// Maps an object to an analytics event and pushes the event to the atm queue.
    /// </summary>
    /// <param name="data">An object which is used to populate the event.</param>
    /// <param name="mapperFn">
    /// A function which is used to map the data to a valid analytics event. If the mapper is
    /// an injectable function, it will be injected with its dependencies.
    /// </param>
    try {

        if (!this.isInit && this.$window.s) {
            this.digitalData = this.$window.digitalData;
            // this.$window.s.t(); // add this line back when 2datafish js will be updated
            this.isInit = true;
        }

        if (customArea) {
            data.areaViewed = customArea;
        }

        const eventToSend = this.mapData(data, mapperFn);

        // add global atm infos to the event
        if (eventToSend && eventToSend.eventContext) {
            eventToSend.eventContext.gContext = this.mapData(this.globalContextService.getGlobalContext(), atmGlobalMapper);
        }

        if (eventToSend && eventToSend.event === 'pageUpdate' && eventToSend.eventContext && eventToSend.eventContext.pageName) {
            eventToSend.eventContext.gContext.pageInfo['pageID'] = eventToSend.eventContext.pageName
        }        

        const analyticsUtilities = this.$window.adobeDynamicUtilities;

        if (analyticsUtilities) {
            if (!this.eventPageUpdateAlreadySaved(eventToSend)) {
                try {
                    analyticsUtilities.eventWrite(eventToSend);
                    //Remove stateParams from pageUpdate event. This is a duplicate data and already available in BWSAUkeywordSearch event.
                    const searchEvent = window.digitalData.events[window.digitalData.events.length - 1];
                    if (searchEvent.event === 'BWSAUkeywordSearch') {
                        _.forEach(window.digitalData.events, function (evt) {
                            if (evt.event === 'pageUpdate' && !_.isUndefined(evt.eventContext.gContext.pageInfo.stateParams) && !_.isUndefined(evt.eventContext.gContext.pageInfo.stateParams.searchTerm)) {
                                delete evt.eventContext.gContext.pageInfo.stateParams;
                            }
                        });
                    }
                } catch (e) {
                    // Ignore any error from within analyticsUtilities, typically in dev environment.
                }
            }
        } else {
            // todo: ask 2datafish to provide an event or a method to know if their lib is ready
            if (!isRecursive) {
                isRecursive = true;
                const magicRetryNumber = 1000;
                this.$timeout(() => {
                    this.push(data, mapperFn, isRecursive);
                }, magicRetryNumber, false);
            } else {
                this.$log.log('Adobe Analytics not found');
            }
        }

        // allow chaining
        return this;

    } catch (e) {
        this.$log.error(e);
    }
};

// fix a defect from Woolworths online on duplicate pageUpdate events
// check if the new event is a pageUpdate and was already send at the last position of the digitalData array
atm.prototype.eventPageUpdateAlreadySaved = function (newEvent) {

    if (window.digitalData && window.digitalData.events && window.digitalData.events.length > 0) {
        const lastEvent = window.digitalData.events[window.digitalData.events.length - 1];

        if (lastEvent.event === 'pageUpdate'
            && lastEvent.eventContext
            && newEvent
            && newEvent.eventContext
            && lastEvent.eventContext.pageTitle && lastEvent.eventContext.pageTitle === newEvent.eventContext.pageTitle) {
            if (lastEvent.eventContext.gContext
                && lastEvent.eventContext.gContext.pageInfo
                && lastEvent.eventContext.gContext.pageInfo.fullURL
                && lastEvent.eventContext.gContext.pageInfo.fullURL !== newEvent.eventContext.gContext.pageInfo.fullURL) {
                return false;
            }

            return true;
        }
    }

    return false;
};

atm.prototype.mapData = function (data, mapperFn) {
    if (!mapperFn) {
        return data;
    }

    return mapperFn.$inject || _.isArray(mapperFn)
        ? this.$injector.invoke(mapperFn, null, { trackingData: data })
        : mapperFn(data);
};

module.exports = atm;



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/analytics/atm-service.js
 **/